import React from 'react';
import {Link, NavLink, Route, Routes} from "react-router-dom";
import {Col, Container, Row} from "react-bootstrap";


export default class Payments extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            paymentCards: null,
            paymentCardsIsLoaded: false,
            isLoadedGeneralInfo: false,
            generalInfo: null,
            revenue: 0,
            revenueIsLoaded: false,
            payouts: null,
            payoutsIsLoaded: false,
            paymentData: null,
            paymentDataIsLoaded: false,
            settings: null,
            isSettingsLoaded: false,
        };
    }

    componentDidMount() {
        console.log(JSON.stringify(this.props));

        fetch(process.env.REACT_APP_API_URL + "/settings/1", {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    console.log(result);
                    this.setState({
                        isSettingsLoaded: true,
                        settings: result
                    });
                },
                (error) => {
                    this.setState({
                        isSettingsLoaded: true,
                        error
                    });
                }
            )

        if(this.props.userId) {
            fetch(process.env.REACT_APP_API_URL + "/customer/" + this.props.userId, {
                headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            isLoadedGeneralInfo: true,
                            generalInfo: result.data
                        });
                    },

                    (error) => {
                        this.setState({
                            isLoadedGeneralInfo: true,
                            error
                        });
                    }
                )

            fetch(process.env.REACT_APP_API_URL + "/payouts/user/" + this.props.userId.toString(), {
                headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            payoutsIsLoaded: true,
                            payouts: result
                        });
                    },

                    (error) => {
                        this.setState({
                            payoutsIsLoaded: true,
                            error
                        });
                    }
                )

            fetch(process.env.REACT_APP_API_URL + "/financial-events/company/" + this.props.userId + "/total-amount", {
                headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            revenueIsLoaded: true,
                            revenue: result
                        });
                    },

                    (error) => {
                        this.setState({
                            revenueIsLoaded: true,
                            error
                        });
                    }
                )

            fetch(process.env.REACT_APP_API_URL + "/my-account/" + this.props.userId + "/card", {
                headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            paymentCardsIsLoaded: true,
                            paymentCards: result
                        });
                    },

                    (error) => {
                        this.setState({
                            paymentCardsIsLoaded: true,
                            error
                        });
                    }
                )

            fetch(process.env.REACT_APP_API_URL + "/my-account/"+this.props.userId+"/card/default", {
                headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            paymentData: result,
                            paymentDataIsLoaded: true
                        });
                    },

                    (error) => {
                        console.log(error);

                        this.setState({
                            paymentDataIsLoaded: false,
                            error
                        });
                    }
                )
        }
    }

    add(e){
        e.preventDefault();

        const address = {
            'line1': e.target.address.value,
            'postal_code': e.target.zip.value,
            'country': e.target.country.value,
            'state': e.target.state.value,
            'city': e.target.city.value
        };

        const body = {
            'number': e.target.cardnumber.value,
            'cvc': e.target.cardcvc.value,
            'exp_month': e.target.expmonth.value,
            'exp_year': e.target.expyear.value,
            'address': address,
        };

        console.log(body);

        fetch(process.env.REACT_APP_API_URL + "/my-account/" + this.props.userId + "/card", {
            method: "POST",
            body: JSON.stringify(body),
            headers: {'Content-Type': 'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.componentDidMount()

                    e.target.address.value = "";
                    e.target.zip.value = "";
                    e.target.country.value = "";
                    e.target.state.value = "";
                    e.target.city.value = "";

                    e.target.cardnumber.value = "";
                    e.target.cardcvc.value = "";
                    e.target.expmonth.value = "";
                    e.target.expyear.value = "";
                },

                (error) => {
                    this.componentDidMount()
                },
            )
    }

    makeDefault(e){
        e.preventDefault();

        fetch(process.env.REACT_APP_API_URL + "/my-account/" + this.props.userId + "/card/" + e.target.card_id.value + "/make-default", {
            method: "PUT",
            headers: {'Content-Type': 'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.componentDidMount()
                },

                (error) => {
                    console.log(error);
                    this.componentDidMount()
                }
            )
    }

    delete(e){
        e.preventDefault();

        fetch(process.env.REACT_APP_API_URL + "/my-account/" + this.props.userId + "/card/" + e.target.card_id.value, {
            method: "DELETE",
            headers: {'Content-Type': 'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.componentDidMount()
                },

                (error) => {
                    console.log(error);
                    this.componentDidMount()
                }
            )
    }

    deleteAll(e){
        e.preventDefault();

        fetch(process.env.REACT_APP_API_URL + "/my-account/" + this.props.userId + "/card/all", {
            method: "DELETE",
            headers: {'Content-Type': 'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(
                (result) => {
                    this.componentDidMount()
                },

                (error) => {
                    console.log(error);

                    this.componentDidMount()
                }
            )
    }

    requestPayout(e){
        e.preventDefault();

        this.setState({
            paymentCardsIsLoaded: false
        });

        fetch(process.env.REACT_APP_API_URL + "/payouts", {
            method: "POST",
            body: JSON.stringify({
                'amount': e.target.amount.value,
                'user_id': this.props.userId,
                'company_id': this.props.userId,
                'partner_type': 'publisher',
            }),
            headers: {'Content-Type': 'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(
                (result) => {
                    this.componentDidMount()

                    this.setState({
                        paymentCardsIsLoaded: true
                    });
                },

                (error) => {
                    console.log(error);

                    this.componentDidMount()

                    this.setState({
                        paymentCardsIsLoaded: true
                    });
                }
            )
    }

    render() {
        const { paymentData, paymentDataIsLoaded, generalInfo, isLoadedGeneralInfo, paymentCardsIsLoaded, error, paymentCards, revenue, payouts, revenueIsLoaded, payoutsIsLoaded, settings, isSettingsLoaded } = this.state;

        let revenueInfo = <span></span>;

        if (isLoadedGeneralInfo && isSettingsLoaded) {
            if (generalInfo.companies.length > 0 && revenueIsLoaded && payoutsIsLoaded) {
                revenueInfo = <div>
                    <h3>Available revenue: ${revenue}</h3>
                    {payouts && payouts.length > 0 ? <div>
                        <h3>Recent payouts</h3>
                        {payouts.map(item => (
                            <div class={item.status==='in_review' ? "alert alert-warning" : "alert alert-success"}>
                                ${item.amount}
                                <br/>
                                {item.created_at}
                                <br/>
                                {item.status==='in_review' ? "In review" : "Approved"}
                            </div>
                        ))}
                    </div> : <hr/>}
                    {
                        revenue >= 100 ?
                            <div>
                                <h4>Request payout</h4>
                                <p>{paymentData ? "Default card will be used: " + paymentData.number : "Add credit card"}</p>
                                <form onSubmit={this.requestPayout.bind(this)}>
                                    <label>Amount:</label>
                                    <br/>
                                    <input readOnly type="number" name="amount" value={revenue}/>
                                    <input type="submit" value="Request"/>
                                </form>
                            </div>
                            : <span></span>
                    }
                </div>
            }
        }

        let content = null;

        if (error) {
            content = <div>{error ? <div className="alert alert-danger">
                    <p>Session token has expired. Please, <a href="/account">login</a> again</p>
                </div> :<empty/>}
            </div>;
        } else if (!paymentCardsIsLoaded || !isSettingsLoaded) {
            content = <div>Loading...</div>;
        } else {
            content = (
                <div>
                    {revenueInfo}
                    {paymentCards.length > 0 && (settings.is_paid_apps_allowed && settings.is_paid_company_allowed) ?
                        <div>
                            <h3>Payment cards</h3>
                            <hr/>
                            {paymentCards.map(item => (
                                <div>
                                    <h4>{item.is_default ? item.number + " - current default" : item.number}</h4>
                                    <form onSubmit={this.makeDefault.bind(this)}>
                                        <input type="text" hidden name="card_id" value={item.id}/>
                                        <input class="btn btn-outline-primary" type="submit" value="Make default"/>
                                    </form>
                                    <form onSubmit={this.delete.bind(this)}>
                                        <input type="text" hidden name="card_id" value={item.id}/>
                                        <input class="btn btn-outline-danger" type="submit" value="Delete"/>
                                    </form>
                                    <hr/>
                                </div>
                            ))}
                        </div> : <div><h3>No cards</h3></div>}

                    {(settings.is_paid_apps_allowed && settings.is_paid_company_allowed)
                        ? <form onSubmit={this.deleteAll.bind(this)}>
                            <input class="btn btn-danger" type="submit" value="Delete all"/>
                        </form>
                        : <br/>
                    }

                    <br/>
                    {
                        (settings.is_paid_apps_allowed && settings.is_paid_company_allowed) ?
                            <div>
                                <button className="btn btn-outline-success" id='manage-payment-card-button'
                                        onClick={(e) => {
                                            let block = document.getElementById('manage-payment-card');

                                            if (block.style.display === 'none') {
                                                block.style.display = 'block';
                                            } else {
                                                block.style.display = 'none';
                                            }
                                        }}>Add payment card
                                </button>
                                <form style={{display: 'none'}} id='manage-payment-card' onSubmit={this.add.bind(this)}>
                                    <hr/>
                                    <label htmlFor="ccnum">Credit card number</label>
                                    <input className="form-control" type="text" id="ccnum" name="cardnumber"
                                           placeholder="1111-2222-3333-4444"/>
                                    <br/>
                                    <label htmlFor="expmonth">Exp Month</label>
                                    <input className="form-control" type="text" id="expmonth" name="expmonth"
                                           placeholder="September"/>
                                    <br/>
                                    <div className="row">
                                        <div className="col-50">
                                            <label htmlFor="expyear">Exp Year</label>
                                            <input className="form-control" type="text" id="expyear" name="expyear"
                                                   placeholder="2023"/>
                                        </div>
                                        <div className="col-50">
                                            <label htmlFor="cvv">CVV</label>
                                            <input className="form-control" type="text" id="cvv" name="cardcvc"
                                                   placeholder="352"/>
                                        </div>
                                    </div>
                                    <div className="col-50">
                                        <h3>Billing Address</h3>
                                        <label htmlFor="adr">Address</label>
                                        <input className="form-control" type="text" id="adr" name="address"
                                               placeholder="542 W. 15th Street"/>
                                        <label htmlFor="city">City</label>
                                        <input className="form-control" type="text" id="city" name="city"
                                               placeholder="New York"/>

                                        <div className="row">
                                            <div className="col-50">
                                                <label htmlFor="state">State</label>
                                                <input className="form-control" type="text" id="state" name="state"
                                                       placeholder="NY"/>
                                            </div>
                                            <div className="col-50">
                                                <label htmlFor="state">Country</label>
                                                <input className="form-control" type="text" id="country" name="country"
                                                       placeholder="USA"/>
                                            </div>
                                            <div className="col-50">
                                                <label htmlFor="zip">Zip</label>
                                                <input className="form-control" type="text" id="zip" name="zip"
                                                       placeholder="10001"/>
                                            </div>
                                        </div>
                                    </div>
                                    <input className="btn btn-success" type="submit" value="Add"/>
                                </form>
                            </div>
                            : <br/>
                    }
                </div>
            );
        }

        return <Container>
            <Row>
                <Col>
                    {content}
                </Col>
            </Row>
        </Container>;
    }
}
